export default "__VITE_PUBLIC_ASSET__e6835858__"